module.exports = __webpack_public_path__ + "static/media/shiny.cff0fad8.png";